import { css } from 'aphrodite';
import * as React from 'react';
import { IPhoneNumber } from '../../../extViewmodels';
import { BoxingGloveIcon } from '../svgs/icons/BoxingGloveIcon';
import { styleSheet } from './styles';

interface IProps {
	companyId?: string;
	contactId?: string;
	phoneNumber: IPhoneNumber;
	isDirectLine?: boolean;
	onSparClick?: (contactId?: string) => void;
}

export const SparButton: React.FC<IProps> = ({ contactId, onSparClick }) => {
	const handleSparClick = () => {
		onSparClick?.(contactId);
	};

	return (
		<button className={css(styleSheet.callCta)} onClick={handleSparClick}>
			<span>
				<BoxingGloveIcon fill='#fff' />
				<span className={css(styleSheet.sparButtonText)}>Spar</span>
			</span>
		</button>
	);
};

export const DirectLineSparButton: React.FC<IProps> = ({ contactId, onSparClick }) => {
	const handleSparClick = () => {
		onSparClick?.(contactId);
	};

	return (
		<button className={css(styleSheet.directLineCta)} onClick={handleSparClick}>
			<span>
				<BoxingGloveIcon fill='#fff' />
				<span style={{ marginLeft: '6px' }}>Spar</span>
			</span>
		</button>
	);
};

export const SmallSparButton: React.FC<IProps> = ({ contactId, onSparClick }) => {
	const handleSparClick = () => {
		onSparClick?.(contactId);
	};

	return (
		<button className={css(styleSheet.smallCallButton)} onClick={handleSparClick}>
			<span>Spar</span>
		</button>
	);
};

export const SmallDirectLineSparButton: React.FC<IProps> = ({ contactId, onSparClick }) => {
	const handleSparClick = () => {
		onSparClick?.(contactId);
	};

	return (
		<button className={css(styleSheet.smallDirectLineButton)} onClick={handleSparClick}>
			<span>Spar</span>
		</button>
	);
};
